import React, { createContext, useContext } from 'react';

const PageConfigContext = createContext(null);

export const usePageConfig = () => {
  const context = useContext(PageConfigContext);
  return context;
};

export const PageConfigProvider = PageConfigContext.Provider;
